var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagrama(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.968,
    height: 25.162,
    viewBox: "0 0 20.968 25.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "diagram-2-fill",
    d: "M9.291,5.145A3.145,3.145,0,0,1,12.436,2h2.1a3.145,3.145,0,0,1,3.145,3.145v2.1a3.145,3.145,0,0,1-3.145,3.145v2.1h5.242a1.048,1.048,0,0,1,1.048,1.048v2.1a1.048,1.048,0,0,1-2.1,0V14.581H8.242v1.048a1.048,1.048,0,0,1-2.1,0v-2.1a1.048,1.048,0,0,1,1.048-1.048h5.242v-2.1A3.145,3.145,0,0,1,9.291,7.242ZM3,21.92a3.145,3.145,0,0,1,3.145-3.145h2.1a3.145,3.145,0,0,1,3.145,3.145v2.1a3.145,3.145,0,0,1-3.145,3.145h-2.1A3.145,3.145,0,0,1,3,24.017Zm12.581,0a3.145,3.145,0,0,1,3.145-3.145h2.1a3.145,3.145,0,0,1,3.145,3.145v2.1a3.145,3.145,0,0,1-3.145,3.145h-2.1a3.145,3.145,0,0,1-3.145-3.145Z",
    transform: "translate(-3 -2)",
    fill: "#003082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagrama);
export default __webpack_public_path__ + "static/media/diagrama.33c2bddec1b4d63261b3f138cd7c5ea2.svg";
export { ForwardRef as ReactComponent };